const sgsw = {
    name: '"SGSW"',
    id: 1,
    fav: '"sgsw/favicon.png"',
    appTitle: '"Solar"',
    namingVal: '"sgsw"',
    scss: {
        main: '"@/assets/scss/_main.scss"',
        variables: '"@/assets/scss/generic/_variables.scss"',
    },
    links: {
        home: {
            link: '"https://www.sgsw.ch/"',
            text: '"St.Galler Stadtwerke"',
        },
        impressum: {
            link: '"https://www.sgsw.ch/f/impressum.html"',
            text: '"Impressum"',
        },
        disclaimer: {
            link: '"https://www.sgsw.ch/f/datenschutz.html"',
            text: '"Datenschutz"',
        },
    },
    gtmID: '"GTM-KFRRJSX"',
};

const rorschacherberg = {
    name: '"Rorschacherberg"',
    id: 2,
    fav: '"rorschacherberg/favicon.png"',
    appTitle: '"Rorschacherberg"',
    namingVal: '"Rorschacherberg"',
    scss: {
        main: '"@/assets/scss/_main-ror.scss"',
        variables: '"@/assets/scss/generic/_variables-ror.scss"',
    },
    links: {
        home: {
            link: '"https://www.sgsw.ch/"',
            text: '"St.Galler Stadtwerke"',
        },
        terms: {
            link: '"static/rorschacherberg/AGB_PVA_Rorschacherberg.pdf"',
            text: '"Allgemeinen Geschäftsbestimmungen"',
        },
        impressum: {
            link: '"https://www.sgsw.ch/f/impressum.html"',
            text: '"Impressum"',
        },
        disclaimer: {
            link: '"https://www.sgsw.ch/f/datenschutz.html"',
            text: '"Datenschutz"',
        },
        tel: {
            link: '"tel:058 228 80 00"',
            text: '"058 228 80 00"',
        },
        email: {
            link: '"mailto:info@rorschacherberg.ch"',
            text: '"info@rorschacherberg.ch"',
        },
        address: {
            link: '"#"',
            text: '"Goldacherstrasse 67"',
        },
        zip: {
            link: '"#"',
            text: '"9404 Rorschacherberg"',
        },
    },
    gtmID: '"GTM-N8SDVW3"',
};

module.exports = [sgsw, rorschacherberg];



//////////////////
// WEBPACK FOOTER
// ./.suppliers.js
// module id = mszl
// module chunks = 1